import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50002 7.5C4.19668 7.5 3.9232 7.68273 3.80711 7.96299C3.69103 8.24324 3.75519 8.56583 3.96969 8.78033L11.4697 16.2803C11.7626 16.5732 12.2375 16.5732 12.5304 16.2803L20.0304 8.78033C20.2449 8.56583 20.309 8.24324 20.1929 7.96299C20.0768 7.68273 19.8034 7.5 19.5 7.5H4.50002Z"
        fill={colorValue}
      />
    </svg>
  );
};
